import { getLocalTimeZone, today } from '@internationalized/date';
import { z } from 'zod';
import { isValidWebsiteUrl } from '../../common/utils/url-validation';
import { calendarDateSchema, requiredString } from '../../common/validations';

export function legalRegistrationDateSchema(message: string) {
  return calendarDateSchema.refine(
    val => val !== null && val.compare(today(getLocalTimeZone())) < 0,
    { message }
  );
}

export function legalNumberSchema(message: string) {
  return requiredString(message);
}

export const websiteUrlSchema = z
  .string()
  .trim()
  .optional()
  .refine(val => val === undefined || val === '' || isValidWebsiteUrl(val), {
    message: 'invalid-website-url',
  });
